import {Component, inject, OnDestroy} from "@angular/core";
import {map, Subscription} from "rxjs";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {GeneralPartnerActions} from "../../store/fund.actions";
import {selectSelectedGeneralPartner, selectSelectedGeneralPartnerIsArchived} from "../../store/general-partner/general-partner.selectors";
import {DocumentGeneratorComponent} from "../../../shared/components/document-generator/document-generator.component";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmationComponent} from "../../../shared/components/confirmation/confirmation.component";

@Component({
    selector: "valumize-general-partner-details-page",
    templateUrl: "./general-partner-details-page.component.html",
    styleUrls: ["./general-partner-details-page.component.scss"],
    standalone: false
})
export class GeneralPartnerDetailsPageComponent implements OnDestroy {
    private readonly store = inject(Store);
    private readonly route = inject(ActivatedRoute);
    private readonly dialog = inject(MatDialog);
    private readonly router = inject(Router);

    subscriptions: Subscription[] = [];
    generalPartnerId?: number;

    selectedGeneralPartner$ = this.store.select(selectSelectedGeneralPartner);
    isArchived$ = this.store.select(selectSelectedGeneralPartnerIsArchived);

    constructor(
    ) {
        this.subscriptions.push(this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.generalPartnerId = Number(this.route.snapshot.paramMap.get("gpId"));
                this.store.dispatch(GeneralPartnerActions.load({generalPartnerId: this.generalPartnerId}));
            }
        }));
    }

    onGPMenuButtonClick(event: Event): void {
        // Remove focus from the button to avoid the aria-hidden conflict. Without this, the focused button is hidden and triggers an accessibility error.
        (event.currentTarget as HTMLElement).blur();
    }

    openDocumentGeneratorDialog(){
        const dialogRef = this.dialog.open(DocumentGeneratorComponent);
        dialogRef.componentInstance.context = "GENERAL_PARTNER";
    }

    openArchiveConfirmation(archived: boolean): void {
        const dialogRef = this.dialog.open(ConfirmationComponent);
        dialogRef.componentInstance.confirmMessage = `Are you sure you want to ${archived ? "archive" : "unarchive"} this general partner?`;

        dialogRef.afterClosed().pipe(
            map(result => {
                if (result) {
                    this.store.dispatch(GeneralPartnerActions.archive({ archived }));
                }
            })
        ).subscribe();
    }

    scrollToComponent = (componentId: string) => document.getElementById(componentId)?.scrollIntoView({behavior: "auto"});

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
